export default __webpack_public_path__ + "static/img/vogue_scene_animated_0585.69b8084.jpg";